import React from "react"

export default function() {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.41 21.41" style={{height: "1em"}}>
    <line y1="10.71" x2="20" y2="10.71" style={{fill:"none", stroke: "currentColor", strokeMiterlimit:10, strokeWidth: "2px"}}/>
    <polyline points="10 0.71 20 10.71 10 20.71" style={{fill: "none", stroke: "currentColor", strokeMiterlimit:10, strokeWidth:"2px"}}/>
  </svg>
}
